import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Button,
  CircularProgress,
  Link,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Slide } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { basePath } from 'base-routes';
import { dpBaseRoutes } from 'base-routes';
import { withRouter } from 'react-router-dom';
import { generalAuthTokenHeader } from '__helpers/auth-header';
import { apiPath } from 'api';
import { userService } from '_services/user.service';
import SurveyGeneralPreview from './SurveyGeneralPreview';
import close from '../../../assets/img/close.svg';
import functionStatus from '../../../assets/img/function.jpg';
import medication from '../../../assets/img/medication.jpg';
import other from '../../../assets/img/other.jpg';
import social from '../../../assets/img/social.jpg';
import pain from '../../../assets/img/pain.jpg';
import congnitive from '../../../assets/img/congnitive.jpg';
import navbar from '../../../assets/img/navbar.svg';
import deleteIcons from '../../../assets/img/delete.svg';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

class EditSurvey extends Component {
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    let userinfo = JSON.parse(localStorage.getItem("_user_info"));

    this.state = {
      modalStatus: false, // Controls modal open/close
      confirmModalMessage: '',
      confirmModalStatus: false,
      loading: false,
      dischargePlannerId: userinfo.dischargePlanner.id,
      showPreview: false,
      previewPayload: null,
      surveys: [],
      spinner: spinner,
      surveyData: [], // Store the survey data here
      tasks: [], // Your existing task data
      templateName: '',
      questions: [
        {
          questionText: '',
          inputTypeId: null,
          options: [],
          required: false,
          weightage: 0,
          questionOrder: null,
        }
      ],
      currentDomainIndex: 0,
      domains: [],
      domainQuestions: [[], [], [], [], []],
      otherQuestions: [],
      surveyTitle: '',
      surveyDescription: '',
      introText: '',
      closingText: 'Thank you for your time!',
       errors: []
    };
  }

  // Method to open the modal
  openSurveyModal = () => {
    this.setState({ modalStatus: true });
  };

  // Method to close the modal
  modalClose = () => {
    this.setState({ modalStatus: false });
    this.props.history.push(basePath + dpBaseRoutes.surveyTemplate.path);
  };


  // Handle question text input change
handleQuestionChange = (index, event) => {
  const newQuestions = [...this.state.questions];
  newQuestions[index].questionText = event.target.value;

  const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

  if (isOtherDomain) {
    this.setState({
      questions: newQuestions,
      otherQuestions: newQuestions
    });
  } else {
    const updatedDomainQuestions = [...this.state.domainQuestions];
    updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;

    this.setState({
      questions: newQuestions,
      domainQuestions: updatedDomainQuestions
    });
  }
};


handleTypeChange = (qIndex, e) => {
  const newQuestions = [...this.state.questions];
  const selectedType = e.target.value;

  const selectedTypeDetails = this.state.surveys.find(
    survey => survey.type === selectedType
  );

  newQuestions[qIndex].type = selectedType;
  newQuestions[qIndex].inputTypeId = selectedTypeDetails ? selectedTypeDetails.id : null;
  newQuestions[qIndex].inputTypeName = selectedTypeDetails
    ? selectedTypeDetails.inputTypeName || selectedType
    : selectedType;

  // Reset options based on the selected type
  if (selectedType === 'Checkbox' || selectedType === 'Multiple Choice') {
    newQuestions[qIndex].options = [{ optionText: 'Option 1', optionId: null }]; // Always 1 option
  } else if (selectedType === 'Rating') {
    newQuestions[qIndex].options = [
      { optionId: null, optionText: '1' },
      { optionId: null, optionText: '2' },
      { optionId: null, optionText: '3' },
      { optionId: null, optionText: '4' },
      { optionId: null, optionText: '5' }
    ]; // Always 5 options
  } else {
    newQuestions[qIndex].options = []; // Clear for other types
  }

  const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

  if (isOtherDomain) {
    this.setState({
      questions: newQuestions,
      otherQuestions: newQuestions
    });
  } else {
    const updatedDomainQuestions = [...this.state.domainQuestions];
    updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
    this.setState({
      questions: newQuestions,
      domainQuestions: updatedDomainQuestions
    });
  }
};

  // Handle option input change for checkbox/radio types
  handleOptionChange = (qIndex, oIndex, event) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options[oIndex].optionText = event.target.value;

    const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

    if (isOtherDomain) {
      this.setState({
        questions: newQuestions,
        otherQuestions: newQuestions
      });
    } else {
      const updatedDomainQuestions = [...this.state.domainQuestions];
      updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
      this.setState({
        questions: newQuestions,
        domainQuestions: updatedDomainQuestions
      });
    }
  };


  // Add a new option for checkbox/radio type
  addOption = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options.push({ optionText: '', optionId: null });
    this.setState({ questions: newQuestions });
  };

  // Add a new question
  addQuestion = () => {
    const newQuestions = [...this.state.questions];
    newQuestions.push({
      questionId: null,
      questionText: '',
      type: '',
      inputTypeId: null,
      options: [],
      weightage: 0,
      required: false,
      isDefault: false,
      questionOrder: newQuestions.length + 1,
    });

    const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;
    if (isOtherDomain) {
      this.setState({
        otherQuestions: newQuestions,
        questions: newQuestions
      });
    } else {
      const updatedDomainQuestions = [...this.state.domainQuestions];
      updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
      this.setState({
        domainQuestions: updatedDomainQuestions,
        questions: newQuestions
      });
    }
  };


  handleWeightageChange = (index, event) => {
    const newQuestions = [...this.state.questions];
    newQuestions[index].weightage = event.target.value;
    this.setState({ questions: newQuestions });
  };

  // handleRequiredChange = (index) => {
  //   const newQuestions = [...this.state.questions];
  //   newQuestions[index].required = !newQuestions[index].required;
  //   this.setState({ questions: newQuestions });
  // };


  handleRequiredChange = (qIndex) => {
  this.setState(prevState => {
    const updatedQuestions = [...prevState.questions];
    updatedQuestions[qIndex] = {
      ...updatedQuestions[qIndex],
      required: !updatedQuestions[qIndex].required
    };

    const updatedDomainQuestions = [...prevState.domainQuestions];
    let updatedOtherQuestions = [...prevState.otherQuestions];

    if (prevState.currentDomainIndex === prevState.domains.length) {
      // Other Domain
      updatedOtherQuestions = updatedQuestions;
    } else {
      updatedDomainQuestions[prevState.currentDomainIndex] = updatedQuestions;
    }

    return {
      questions: updatedQuestions,
      domainQuestions: updatedDomainQuestions,
      otherQuestions: updatedOtherQuestions
    };
  });
};


  // Submit survey data
  handleSurveySubmit = () => {
    console.log('Survey Submitted:', this.state.questions);
    this.setState({ modalStatus: false }); // Close modal after submission
  };

  renderInputPreview = (type, options = []) => {
    switch (type) {
      case 'Short Answer':
        return <input type="text" placeholder="Short Answer" style={{ width: '25%',  border: '1px solid #ccc',
        padding: '10px',
        marginBottom: '20px',
        borderRadius: '8px',
        height: '40px' }}/>;

      case 'Paragraph':
        return <textarea placeholder="Paragraph" style={{ width: '25%',  border: '1px solid #ccc',
        padding: '10px',
        marginBottom: '20px',
        borderRadius: '8px',
        height: '40px' }}></textarea>;

      case 'Checkbox':
        return options && options.length > 0 ? options.map((option, index) => (
          <div key={option.optionId ?? index}>
            <input type="checkbox" id={`option-${option.optionId ?? index}`} />
            <label htmlFor={`option-${option.optionId ?? index}`}  style={{ marginLeft: '10px' }}>{option.optionText}</label>
          </div>
        )) : <p style={{ color: 'gray' }}>No options added.</p>;

      case 'Multiple Choice':
        return options && options.length > 0 ? options.map((option, index) => (
          <div key={option.optionId ?? index}>
            <input type="radio" name="preview" id={`option-${option.optionId ?? index}`} />
            <label htmlFor={`option-${option.optionId ?? index}`}  style={{ marginLeft: '10px' }}>{option.optionText}</label>
          </div>
        )) : <p style={{ color: 'gray' }}>No options added.</p>;

      case 'Rating':
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '130px' }}>
            <span style={{ fontWeight: 'bold' }}>Poor</span>
            {options.map((option, index) => (
              <label key={option.optionId ?? index} style={{ display: 'flex',  alignItems: 'center' }}>
                <input
                  type="radio"
                  name="rating"
                  value={option.optionText}
                />
                <span style={{ marginLeft: '10px', fontWeight:'500' }}>{option.optionText}</span>
              </label>
            ))}
            <span style={{ fontWeight: 'bold' }}>Excellent</span>
          </div>
        );


      default:
        return null;
    }
  };

  handleTitleChange = (e) => {
    this.setState({ surveyTitle: e.target.value });
  };

  handleDescriptionChange = (e) => {
    this.setState({ surveyDescription: e.target.value });
  };
  handleClosingTextChange = (e) => {
    this.setState({ closingText: e.target.value });
  };
  reorderQuestions = (questions, startIndex, endIndex) => {
    const result = Array.from(questions);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    // Update questionOrder for all questions while maintaining all other properties
    return result.map((q, idx) => ({
      ...q,
      questionOrder: idx + 1
    }));
  };

  onDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index && source.droppableId === destination.droppableId) return;

    const reordered = this.reorderQuestions(this.state.questions, source.index, destination.index);

    // Update both the current questions and the appropriate storage (domainQuestions or otherQuestions)
    const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

    if (isOtherDomain) {
      this.setState({
        questions: reordered,
        otherQuestions: reordered
      });
    } else {
      const updatedDomainQuestions = [...this.state.domainQuestions];
      updatedDomainQuestions[this.state.currentDomainIndex] = reordered;
      this.setState({
        questions: reordered,
        domainQuestions: updatedDomainQuestions
      });
    }
  };

  removeOption = (qIndex, oIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options.splice(oIndex, 1);
    this.setState({ questions: newQuestions });
  };

  async fetchInputTypes() {
    this.state.spinner.removeAttribute("hidden", "true");

    let showNotification = {};
    const apiUrl = apiPath.GetAllInputType;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("Input Types Fetched: ", data);

      // 🔥 Map the API response name to internal type
      const mappedData = data.map(item => {
        let type = '';
        if (item.name === 'Short Answer') type = 'Short Answer';
        else if (item.name === 'Paragraph') type = 'Paragraph';
        else if (item.name === 'Multiple Choice') type = 'Multiple Choice';
        else if (item.name === 'Checkbox') type = 'Checkbox';
        else if (item.name === 'Rating') type = 'Rating';

        return {
          ...item,
          type: type

        };
      });

      this.setState({ surveys: mappedData }); // <-- now surveys have correct type

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

    this.state.spinner.setAttribute("hidden", "true");
  }

  async componentDidMount() {
    console.log("Editing survey with ID:", this.props.surveyId);
    this.fetchDomain();
    await this.fetchInputTypes(); // Load input types first

    try {
      //const response = await fetch(apiPath.GetByIdSurveyForm + this.props.surveyId);
      const response = await fetch(apiPath.GetByIdSurveyForm + this.props.surveyId, {
              method: "GET",
              headers: generalAuthTokenHeader(),
            });
      const data = await response.json();
      console.log("getById", data);

      if (response.ok) {
        const domainQuestions = (data.domainQuestions || []).map((domain) => {
          return (domain.questions || []).map((q) => {
            const matchedSurvey = this.state.surveys.find(
              (survey) =>
                survey.name.toLowerCase().replace(/\s/g, '') ===
                q.inputTypeName.toLowerCase().replace(/\s/g, '')
            );

            return {
              questionId: q.questionId, // keep questionId
              questionText: q.questionText,
              inputTypeId: q.inputTypeId || (matchedSurvey ? matchedSurvey.id : null),
              inputTypeName: q.inputTypeName || (matchedSurvey ? matchedSurvey.name : null),
              type: matchedSurvey ? matchedSurvey.type : '',
              weightage: q.weightage,
              required: q.required,
              options: Array.isArray(q.options) ? q.options.map((opt) => ({
                optionId: opt.optionId,
                optionText: opt.optionText
              })) : [],
              questionOrder: q.questionOrder || 1,
              domainId: q.domainId, // keep domainId
              isDefault: q.isDefault || false
            };
          });
        });

        const domainNames = (data.domainQuestions || []).map((d) => ({
          domainId: d.domainId, // keep domainId here too
          name: d.domainName
        }));

        const generalQuestions = (data.generalQuestions?.questions || []).map((q) => {
          const matchedSurvey = this.state.surveys.find(
            (survey) =>
              survey.name.toLowerCase().replace(/\s/g, '') ===
              q.inputTypeName.toLowerCase().replace(/\s/g, '')
          );

          return {
            questionId: q.questionId,
            questionText: q.questionText,
            inputTypeId: q.inputTypeId || (matchedSurvey ? matchedSurvey.id : null),
            inputTypeName: q.inputTypeName || (matchedSurvey ? matchedSurvey.name : null),
            type: matchedSurvey ? matchedSurvey.type : '',
            weightage: q.weightage,
            required: q.required,
            options: Array.isArray(q.options) ? q.options.map((opt) => ({
              optionId: opt.optionId,
              optionText: opt.optionText
            })) : [],
            questionOrder: q.questionOrder || 1,
            domainId: null,
            isDefault: q.isDefault || false
          };
        });

        this.setState({
          surveyTitle: data.title,
          introText: data.introText,
          surveyDescription: data.description,
          closingText: data.endText,
          domains: domainNames,
          domainQuestions: domainQuestions,
          otherQuestions: generalQuestions,
          currentDomainIndex: 0,
          questions: domainQuestions[0] || [],
        });
      } else {
        console.error('Error fetching survey form:', data);
      }
    } catch (error) {
      console.error('Error fetching survey form:', error);
    }
  }


  async fetchDomain() {
    this.state.spinner.removeAttribute("hidden", "true");

    let showNotification = {};
    const apiUrl = apiPath.GetAllDomain;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }

      const data = await response.json();
      console.log("All Domain Fetched: ", data);





      this.setState({ domains: data });


      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

    this.state.spinner.setAttribute("hidden", "true");
  }

  async submitSurveyForm() {
       const isValid = this.validateQuestions();
  if (!isValid) {
    console.log("Validation failed, cannot move to next domain");
    return; // stop if validation fails
  }
    this.state.spinner.removeAttribute("hidden", "true");

    let showNotification = {};
    console.log('Other Questions:', this.state.otherQuestions);
    console.log('Domain Questions:', this.state.domainQuestions);
    // Validate generalQuestions (questionText and inputTypeId must both exist or both be empty)
    for (let i = 0; i < this.state.otherQuestions.length; i++) {
      const q = this.state.otherQuestions[i];
      const hasQuestionText = q.questionText && q.questionText.trim() !== '';
      const hasInputTypeId = q.inputTypeId !== undefined && q.inputTypeId !== null && q.inputTypeId !== '';

      if ((hasQuestionText && !hasInputTypeId) || (!hasQuestionText && hasInputTypeId)) {
        userService.showNotification({
          title: "Validation Error",
          message: `Please fill both Question and Type`,
          type: "warning",
        });
        this.state.spinner.setAttribute("hidden", "true");
        return;
      }
    }

    const apiUrl = apiPath.PutSurveyForm + this.props.surveyId;

    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          title: this.state.surveyTitle,
          introText: this.state.introText,
          description: this.state.surveyDescription,
          endText: this.state.closingText,
          dpId: this.state.dischargePlannerId || 0, // Use your dpId state
          isDefault: this.state.isDefault || false,
          domainQuestions: this.state.domains.map((domain, index) => ({
            domainId: domain.domainId,
            domainName: domain.name,
            questions: this.state.domainQuestions[index]?.map((q, i) => ({
              questionId: q.questionId,
              questionText: q.questionText,
              inputTypeId: q.inputTypeId,
              weightage: q.weightage,
              required: q.required,
              questionOrder: q.questionOrder,
              domainId: domain.domainId,
              isDefault: q.isDefault || false,
              options: q.options?.map(opt =>
                typeof opt === 'string'
                  ? { optionText: opt }
                  : {
                    optionId: opt.optionId,
                    optionText: opt.optionText
                  }
              ) || null,
            })) || []
          })),
          generalQuestions: {
            questions: this.state.otherQuestions.map((q, i) => ({
              questionId: q.questionId,
              questionText: q.questionText,
              inputTypeId: q.inputTypeId,
              weightage: q.weightage,
              required: q.required,
              questionOrder: q.questionOrder,
              domainId: null,
              isDefault: q.isDefault || false,
              options: q.options?.map(opt =>
                typeof opt === 'string'
                  ? { optionText: opt }
                  : {
                    optionId: opt.optionId,
                    optionText: opt.optionText
                  }
              ) || null,
            }))
          }
        }),
      });

      if (response.status === 400) {
        showNotification = { title: "Survey", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Survey", message: "Error submitting survey", type: "danger" };
      } else {
        showNotification = { title: "Survey", message: "Survey updated successfully!", type: "success" };
        this.setState({ modalStatus: false });
        window.location.reload(true);
      }

      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error submitting survey", error);
      showNotification = { title: "Survey", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }

    this.state.spinner.setAttribute("hidden", "true");
  }

  goToNextDomain = () => {
      const isValid = this.validateQuestions();
  if (!isValid) {
    console.log("Validation failed, cannot move to next domain");
    return; // stop if validation fails
  }
    const { currentDomainIndex, domains } = this.state;

    // If already on the last domain (Other Domain), do nothing
    if (currentDomainIndex >= domains.length) {
      return;
    }

    if (this.state.questions.length === 0) {
      return;
    }

    const { questions, domainQuestions, otherQuestions } = this.state;
    const updatedDomainQuestions = [...domainQuestions];
    let updatedOtherQuestions = otherQuestions;

    // Save current questions
    if (currentDomainIndex === domains.length) {
      updatedOtherQuestions = questions;
    } else {
      updatedDomainQuestions[currentDomainIndex] = questions;
    }

    const nextDomainIndex = currentDomainIndex + 1;

    // Load next questions
    let nextQuestions;
    if (nextDomainIndex === domains.length) {
      const otherQs = updatedOtherQuestions || [];
      nextQuestions = otherQs.length > 0
        ? otherQs
        : [{ questionText: '', inputTypeId: null, options: [], weightage: 0, required: false }];
    } else {
      const domainQs = updatedDomainQuestions[nextDomainIndex] || [];
      nextQuestions = domainQs.length > 0
        ? domainQs
        : [{ questionText: '', inputTypeId: null, options: [], weightage: 0, required: false }];
    }

    this.setState({
      currentDomainIndex: nextDomainIndex,
      domainQuestions: updatedDomainQuestions,
      otherQuestions: updatedOtherQuestions,
      questions: nextQuestions.map((q, i) => ({ ...q, questionOrder: i + 1 })),
    });
  };

  removeQuestion = (index) => {
    const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

    // Remove the question
    const updatedQuestions = [...this.state.questions];
    updatedQuestions.splice(index, 1);

    // Recalculate question order
    const reorderedQuestions = updatedQuestions.map((q, idx) => ({
      ...q,
      questionOrder: idx + 1,
    }));

    if (isOtherDomain) {
      this.setState({
        questions: reorderedQuestions,
        otherQuestions: reorderedQuestions,
      });
    } else {
      const updatedDomainQuestions = [...this.state.domainQuestions];
      updatedDomainQuestions[this.state.currentDomainIndex] = reorderedQuestions;

      this.setState({
        questions: reorderedQuestions,
        domainQuestions: updatedDomainQuestions,
      });
    }
  };

  previewSurveyForm = async () => {
    // Show spinner
    if (this.state.spinner) {
      this.state.spinner.removeAttribute("hidden");
    }

    // Clone existing domainQuestions
    const updatedDomainQuestions = [...this.state.domainQuestions];

    // Update either otherQuestions or domainQuestions based on currentDomainIndex
    if (this.state.currentDomainIndex === this.state.domains.length) {
      // Last domain: update otherQuestions
      await new Promise(resolve => {
        this.setState({ otherQuestions: this.state.questions }, resolve);
      });
    } else {
      // Update domain-specific questions
      updatedDomainQuestions[this.state.currentDomainIndex] = this.state.questions;
    }

    // Normalize domain questions
    const normalizedDomainQuestions = updatedDomainQuestions.map((domainQuestions = [], domainIndex) =>
      domainQuestions.map(({ type, ...q }) => ({
        ...q,
        required: domainIndex === 0 ? false : (typeof q.required === 'boolean' ? q.required : false),
        inputTypeName: q.inputTypeName || '',
        options: Array.isArray(q.options)
          ? q.options.map(opt => {
            if (typeof opt === 'string') return { optionText: opt };
            if (opt && typeof opt === 'object' && 'optionText' in opt) return opt;
            return { optionText: String(opt) };
          })
          : [],
      }))
    );

    // Normalize other (general) questions
    const normalizedOtherQuestions = (this.state.otherQuestions || []).map(({ type, ...q }) => ({
      ...q,
      required: typeof q.required === 'boolean' ? q.required : false,
      inputTypeName: q.inputTypeName || '',
      options: Array.isArray(q.options)
        ? q.options.map(opt => {
          if (typeof opt === 'string') return { optionText: opt };
          if (opt && typeof opt === 'object' && 'optionText' in opt) return opt;
          return { optionText: String(opt) };
        })
        : [],
    }));

    // Construct domain structure with questions
    const domains = this.state.domains.map((domain, i) => ({
      domainId: domain.domainid,
      questions: normalizedDomainQuestions[i] || [],
    }));

    // Construct preview payload
    const payload = {
      title: this.state.surveyTitle,
      description: this.state.surveyDescription,
      introText: this.state.introText,
      endText: this.state.closingText,
      dpId: this.state.dischargePlannerId,
      domainQuestions: domains,
      generalQuestions: { questions: normalizedOtherQuestions },
    };

    console.log("payload", payload);

    this.setState({
      previewPayload: payload,
      showPreview: true,
    });

    // Hide spinner
    if (this.state.spinner) {
      this.state.spinner.setAttribute("hidden", "true");
    }
  };
validateQuestions = () => {
  let formErrors = {};

  // validate title
  if (!this.state.surveyTitle.trim()) {
    formErrors.surveyTitle = "Form name is required";
  }

  // choose which questions to validate (normal or other domain)
  const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;
  const questionsToValidate = isOtherDomain
    ? this.state.otherQuestions
    : this.state.questions;

  // validate questions
  const questionErrors = questionsToValidate.map((q) => {
    let err = {};
    const hasQuestion = q.questionText && q.questionText.trim() !== "";
    const hasType = !!q.type;

    if (isOtherDomain) {
      // relaxed rules
      if (!hasQuestion && !hasType) {
        // both empty → allowed, skip validation
        return err;
      }
      if (hasQuestion && !hasType) {
        err.type = "Please select a type";
      }
      if (!hasQuestion && hasType) {
        err.questionText = "Question text is required";
      }
    } else {
      // normal strict rules
      if (!hasQuestion) {
        err.questionText = "Question text is required";
      }
      if (!hasType) {
        err.type = "Please select a type";
      }
    }

    // shared rule: if type requires options
    if (
      hasType &&
      (q.type === "Checkbox" || q.type === "Multiple Choice") &&
      q.options.some((opt) => !opt || !opt.optionText?.trim())
    ) {
      err.options = "All options must be filled";
    }

    return err;
  });

  // update errors in state depending on domain
  if (isOtherDomain) {
    this.setState({ otherErrors: questionErrors, formErrors });
  } else {
    this.setState({ errors: questionErrors, formErrors });
  }

  // overall validation success
  return (
    Object.keys(formErrors).length === 0 &&
    questionErrors.every((err) => Object.keys(err).length === 0)
  );
};


  render() {
    // inside render() before return
      const { currentDomainIndex, domains, errors, otherErrors } = this.state;

const errorSource =
  currentDomainIndex === domains.length ? otherErrors : errors;
    return (
      <div>

        <Dialog
          open={this.props.open}
          maxWidth="xl" // Or 'lg', adjust as needed
          onClose={this.props.onClose}

          TransitionComponent={Transition}
          aria-labelledby="survey-dialog-title"
          fullWidth={true} // Ensure the modal takes full width of the maxWidth
          fullScreen
        >
          <DialogTitle color="success" className={"cusCardTitle"} id="" style={{ color: "white" }}>
            Edit Survey

            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.modalClose}
            >
              {/* <CloseIcon /> */}
              <img src={close} alt="" srcset=""  />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <Box>
              <div style={{ display: 'flex', marginBottom: '20px', justifyContent: 'center'}}>
                {(this.state.domains.concat([{ name: 'Other Domain' }])).map((domain, index, allDomains) => {
                  const isOtherDomain = domain.name === 'Other Domain';
                  const isCurrent = this.state.currentDomainIndex;
                  const isSelected = isCurrent === index;

                  const currentQuestions = isCurrent === this.state.domains.length
                    ? this.state.otherQuestions
                    : this.state.domainQuestions[isCurrent];

                  const allTypesSelected = currentQuestions?.every(q => q.type && q.type !== '');
                  const isDisabled = index > isCurrent && !allTypesSelected;

                  
                  const domainIconsByIndex = [
                    medication,        // index 0
                    functionStatus,    // index 1
                    congnitive,        // index 2
                    pain,              // index 3
                    social,            // index 4
                    other              // index 5
                  ];

                  const isActive = this.state.currentDomainIndex === index;
                  return (
                    <div
                      key={index}
                      disabled={isDisabled}
                      onClick={() => {
                        if (isDisabled) return;

                        const updatedDomainQuestions = [...this.state.domainQuestions];

                        if (isCurrent === allDomains.length - 1) {
                          this.setState({ otherQuestions: this.state.questions });
                        } else {
                          updatedDomainQuestions[isCurrent] = this.state.questions;
                        }

                        let nextQuestions;
                        if (isOtherDomain) {
                          const questions = this.state.otherQuestions?.length > 0
                            ? this.state.otherQuestions
                            : [{ questionText: '', inputTypeId: null, options: [], weightage: 0, required: false ,type: ''}];
                          nextQuestions = questions.map((q, i) => ({ ...q, questionOrder: i + 1 }));
                        } else {
                          const questions = updatedDomainQuestions[index]?.length > 0
                            ? updatedDomainQuestions[index]
                            : [{ questionText: '', inputTypeId: null, options: [], weightage: 0, required: false ,type: ''}];
                          nextQuestions = questions.map((q, i) => ({ ...q, questionOrder: i + 1 }));
                        }

                        this.setState({
                          currentDomainIndex: index,
                          domainQuestions: updatedDomainQuestions,
                          questions: nextQuestions,
                        });
                      }}
                      style={{
                        border: 'none',
                      }}
                    >
                      {/* {domain.name} */}
                      {isActive && (
                          <img 
                            src={domainIconsByIndex[index]} 
                            alt={domain.name} 
                          />
                        )}
                    </div>
                  );
                })}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>

              <input
                type="text"
                placeholder="Untitled form"
                value={this.state.surveyTitle}
                onChange={this.handleTitleChange}
                style={{
                  width: '33.33%',
                  marginBottom: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  padding: '10px',
                  height: '40px'
                }}
              />

              {/* Survey Description */}
              <textarea
                placeholder="Form description"
                value={this.state.surveyDescription}
                onChange={this.handleDescriptionChange}
                style={{
                  width: '66%',
                  resize: 'none',
                  marginLeft: '10px', 
                  border: '1px solid #ccc',
                  padding: '10px',
                  marginBottom: '20px',
                  borderRadius: '8px',
                  height: '40px'
                }}
              />
              </div>
              {/* {this.state.formErrors?.surveyDescription && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {this.state.formErrors.surveyDescription}
  </span>
)} */}
{this.state.formErrors?.surveyTitle && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {this.state.formErrors.surveyTitle}
  </span>
)}


              <DialogContent style={{ padding: 0 }}>

                <DragDropContext onDragEnd={this.onDragEnd}>
                  <Droppable droppableId="questions-droppable">
                    {(provided) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}
                        style={{
                          maxHeight: 600,
                          overflowY: 'auto',
                          padding: '10px',  // add padding here if needed
                          boxSizing: 'border-box'
                        }}>
                        {this.state.questions.map((q, qIndex) => (
                          <Draggable key={qIndex} draggableId={`question-${qIndex}`} index={qIndex}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  userSelect: 'none',
                                  background: snapshot.isDragging ? '#f5f5f5' : 'white',
                                  marginBottom: '30px',
                                  border: '1px solid #ccc',
                                  paddingBottom: '20px',
                                  borderRadius: '8px',
                                  padding: '10px'
                                }}
                              >
                                {/* <h3 style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '10px', cursor: 'grab' }}>☰</span>
                  Question {qIndex + 1}
                  { qIndex >=1 && (
                <button
                onClick={() => this.removeQuestion(qIndex)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'red',
                  cursor: 'pointer',
                  fontSize: '18px'
                }}
                title="Remove Question"
                >
                ❌
                </button>
                )} 
                 
                </h3> */}
                                <h3 style={{ display: 'flex', alignItems: 'center', marginTop: '0px' , width: '100%', justifyContent: 'space-between' }}>
                                <div>
                                <img src={navbar} alt="" srcset="" style={{cursor: 'grab'}}/>
                                <span style={{ color: '#555555',/* Question 1 */fontWeight: 500,
                                  fontSize: '24px',
                                  paddingLeft: '10px'

                                  }}>Question {qIndex + 1}</span> 

                                   </div>
                                   <div>
                                  {(
    this.state.currentDomainIndex === this.state.domains.length || // "Other Domain"
    this.state.questions.length > 1 // normal domains
  ) && (
                                      <button
                                        onClick={() => this.removeQuestion(qIndex)}
                                        style={{
                                          background: 'transparent',
                                          border: 'none',
                                          color: 'red',
                                          cursor: 'pointer',
                                          fontSize: '18px'
                                        }}
                                        title="Remove Question"
                                      >
                                       <img src={deleteIcons} alt="" srcset="" style={{ paddingLeft: '10px' }}/>
                                      </button>
                                    )}
                                    </div>
                                </h3>

                                <input
                                  type="text"
                                  placeholder={`Enter Question ${qIndex + 1}`}
                                  value={q.questionText}
                                  onChange={e => this.handleQuestionChange(qIndex, e)}
                                  style={{ width: '100%',  border: '1px solid #ccc',
                                        padding: '10px',
                                        marginBottom: '20px',
                                        borderRadius: '8px',
                                        height: '40px' }}
                                />
{errorSource?.[qIndex]?.questionText && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {errorSource[qIndex].questionText}
  </span>
)}
                                <div style={{ marginTop: '10px' }}>
                                  <label style={{ marginRight: '10px' }}>Type:</label> <br />
                                  <select
                                    value={q.type || ""}
                                    onChange={e => this.handleTypeChange(qIndex, e)}
                                    style={{ width: '25%',  border: '1px solid #ccc',
                                    padding: '10px',
                                    marginBottom: '20px',
                                    borderRadius: '8px',
                                    height: '40px' }}
                                  >
                                    <option value="">Select Type</option>
                                    {this.state.surveys.map((type, index) => (

                                      <option key={index} value={type.type}>
                                        {type.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
{errorSource?.[qIndex]?.type && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {errorSource[qIndex].type}
  </span>
)}

                                {(q.type === 'Checkbox' || q.type === 'Multiple Choice') && q.options.map((option, oIndex) => (
                                  <div key={oIndex} style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                    <input
                                      type="text"
                                      placeholder={`Option ${oIndex + 1}`}
                                      value={option.optionText}
                                      onChange={e => this.handleOptionChange(qIndex, oIndex, e)}
                                      style={{ width: '25%',border: '1px solid #ccc',
                                      padding: '10px',
                                      marginBottom: '20px',
                                      borderRadius: '8px',
                                      height: '40px'  ,
                                      marginTop: '16  px'
                                    }}
                                    />
                                    {q.options.length > 1 && (
                                      <button
                                        onClick={() => this.removeOption(qIndex, oIndex)}
                                        style={{
                                          background: 'transparent',
                                          border: 'none',
                                          color: 'red', 
                                          cursor: 'pointer',
                                          fontSize: '18px'
                                        }}
                                        title="Remove Option"
                                      >
                                        <img src={deleteIcons} alt="" srcset="" style={{ paddingLeft: '10px' }}/>
                                      </button>
                                    )}
                                  </div>
                                ))}

                                {/* Error message */}
{errorSource?.[qIndex]?.options && (
  <div style={{ color: 'red', fontSize: '12px', marginBottom: '5px' }}>
    {errorSource[qIndex].options}
  </div>
)}

                                {(q.type === 'Checkbox' || q.type === 'Multiple Choice') && (
                                  <button
                                    onClick={() => this.addOption(qIndex)}
                                    style={{ marginTop: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' }}
                                  >
                                     Add Option
                                  </button>
                                )}

                                <div style={{ marginTop: '15px' }}>
                                  <strong>Preview:</strong>
                                  <div style={{ marginTop: '5px' }}>
                                    {this.renderInputPreview(q.type, q.options)}
                                  </div>
                                </div>

                                <div style={{ marginTop: '10px' }}> 
                                  <label style={{ marginRight: '10px' }}>Weightage (Stars 1-5):</label> <br />
                                  <select
                                    value={q.weightage}
                                    onChange={(e) => this.handleWeightageChange(qIndex, e)}
                                    style={{ width: '25%',border: '1px solid #ccc',
                                    padding: '10px',
                                    marginBottom: '20px',
                                    borderRadius: '8px',
                                    height: '40px'  }}
                                  >
                                    <option value={0}>0</option>
                                    <option value={1}>1</option>
                                    <option value={2}>2</option>
                                    <option value={3}>3</option>
                                    <option value={4}>4</option>
                                    <option value={5}>5</option>
                                  </select>
                                </div>

                                <div style={{ marginTop: '10px' }}>
                                  <label style={{ marginRight: '10px' }}>Required:</label>
                                  <input
                                    type="checkbox"
                                    checked={q.required}
                                    onChange={() => this.handleRequiredChange(qIndex)}
                                  />
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </DialogContent>


              {/* <button onClick={this.addQuestion} style={{ marginRight: '10px' }}>
                Add Question
              </button> */}
              {this.state.currentDomainIndex < this.state.domains.length && (
              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <button
                  onClick={this.goToNextDomain}
                  disabled={this.state.questions.length === 0}
                  style={{
                    // padding: '10px 20px',
                    cursor: this.state.questions.length === 0 ? 'not-allowed' : 'pointer',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '20px',
                    padding: '10px',
                    width: '100px',background: '#01A7A6', color: 'white',margin: 'auto',fontWeight: 'bold'
                  }}
                >
                  Next
                </button>
                </div>
                )}

            </Box>
          </DialogContent>
          {/* <textarea
            placeholder="Closing message (e.g., Thank you for your time!)"
            value={this.state.closingText}
            onChange={this.handleClosingTextChange}
            style={{
              width: '100%',
              fontSize: '16px',
              border: 'none',
              borderTop: '1px solid #ccc',
              marginTop: '30px',
              paddingTop: '10px',
              resize: 'none',
              outline: 'none',
              textAlign: 'center',
              color: '#4caf50',
            }}
          /> */}

          <DialogActions>
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%',padding: '8px 24px' }}>
                <div>
                  <button onClick={this.addQuestion}  style={{ marginTop: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' , borderRadius : '20px', height: '40px', width: '125px', fontWeight: '500', fontSize: '14px'}}>
                    Add Question
                  </button>

              </div>
              <div>
                <Button className="pointer btn1 canclebtn" onClick={this.modalClose} color="secondary" style={{background: '#A9A9A9', borderRadius: '20px', height: '40px'}}>
                  Cancel
                </Button>
                <Button
                  onClick={() => this.previewSurveyForm()}
                  color="default"
                  className="pointer btn1"
                  disabled={this.state.loading}
                  style={{ margin: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' , borderRadius : '20px', height: '40px' }}
                >
                  Preview
                </Button>
                <Button onClick={() => this.submitSurveyForm()}
                  color="primary"
                  className="pointer btn1"
                  disabled={this.state.loading}
                  style={{ margin: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' , borderRadius : '20px', height: '40px' }}
                >
                  {this.state.loading && (
                    <CircularProgress size={24} className="buttonProgress" color="secondary" />
                  )}
                  Submit
                </Button>

              </div>
            </div>
          </DialogActions>
          <Dialog
            open={this.state.showPreview}
            onClose={() => this.setState({ showPreview: false })}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              Preview Survey
              <IconButton
                aria-label="close"
                onClick={() => this.setState({ showPreview: false })}
                style={{ position: "absolute", right: 8, top: 8 }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent dividers>
              <SurveyGeneralPreview payload={this.state.previewPayload} />
            </DialogContent>

            <DialogActions>
              <Button onClick={() => this.setState({ showPreview: false })} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>


        </Dialog>
      </div>
    );
  }
}

export default withRouter(EditSurvey);
